import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const AutomatedAnalysisAudioMessage = ({ hasAutomatedAnalysis }) => (
  <div>
    {hasAutomatedAnalysis && (
      <div className="Response-notice mb-16">
        <div>
          <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
            {t('automated_analysis.response_audio_reminder.check')}
          </Text>
          <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
            {t('automated_analysis.response_audio_reminder.requirement')}
          </Text>
        </div>
      </div>
    )}
  </div>
);

export default AutomatedAnalysisAudioMessage;
